import React from 'react';

const SvgIcon = () => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
   width="24px" height="24px" viewBox="0 0 512.000000 512.000000"
   preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
    fill="#000000" stroke="none">
      <path d="M2425 4890 c-249 -39 -474 -182 -614 -389 -47 -69 -1677 -2893 -1718
      -2976 -142 -284 -115 -636 68 -906 123 -182 311 -314 529 -371 l85 -23 1770 0
      c1898 0 1820 -2 1967 50 135 48 228 108 332 211 82 82 134 156 187 267 63 133
      82 219 82 382 0 163 -19 249 -82 381 -37 77 -1605 2801 -1700 2953 -95 153
      -273 307 -418 361 -152 57 -349 81 -488 60z m215 -411 c120 -19 240 -89 308
      -181 45 -60 1669 -2870 1713 -2963 69 -145 53 -329 -41 -474 -76 -119 -210
      -202 -355 -221 -54 -7 -624 -10 -1760 -8 l-1680 3 -67 23 c-276 93 -419 406
      -304 665 20 46 1623 2828 1694 2942 79 126 243 217 402 224 14 0 54 -4 90 -10z"/>
      <path d="M2496 3455 c-84 -22 -148 -82 -187 -175 -18 -46 -17 -110 10 -555 12
      -203 28 -465 35 -581 15 -254 25 -281 115 -326 62 -32 105 -35 159 -12 86 36
      132 118 132 233 -1 31 14 309 32 618 36 619 36 614 -23 699 -56 82 -173 124
      -273 99z"/>
      <path d="M2490 1601 c-121 -39 -197 -148 -188 -268 11 -144 115 -242 257 -243
      102 0 186 52 233 144 26 50 29 163 6 217 -22 50 -74 107 -122 131 -44 22 -145
      33 -186 19z"/>
    </g>
  </svg>
);

export default SvgIcon;
